import {
  EXPORT_ERROR_SENTINELS,
  SearchInvoiceReportsCsvEncode,
  useExportInvoiceReportsMutation,
} from '@/context/services/invoice_reports/InvoiceReportExport.service';
import type { FetchInvoiceReportsArgs } from '@/features/invoice_reports/types';
import { useDownload } from '@/hooks/useDownload';
import { useTranslation } from '@/i18n';
import { toHtmlNode } from '@/utils/toHtmlNode';
import { useToastAPI } from '@moneyforward/ap-frontend-components';
import { useCallback } from 'react';

export const useExportInvoiceReportsQuery = (
  query: FetchInvoiceReportsArgs
) => {
  const { t } = useTranslation();
  const download = useDownload();
  const notify = useToastAPI();

  const { mutateAsync, isPending } = useExportInvoiceReportsMutation();

  const handleExport = useCallback(
    (csv_encode: SearchInvoiceReportsCsvEncode) => async () => {
      try {
        const blob = await mutateAsync({ ...query, csv_encode });
        download({
          value: blob,
          fileName: `${t('invoice_reports.export.filename')}.csv`,
        });
      } catch (error) {
        const apiMsg =
          error instanceof Error && !EXPORT_ERROR_SENTINELS.has(error.message)
            ? error.message
            : undefined;
        notify.error({
          title: toHtmlNode(
            apiMsg ?? t('invoice_reports.export.error_message')
          ),
          duration: 3,
        });
      }
    },
    [mutateAsync, query, download, notify, t]
  );

  return { isLoading: isPending, handleExport };
};
